import { DefaultFilters } from '../../../services/modules/userContextPreferences/userContextPreferences.types';
import { CUSTOMERS_IDS_KEYS } from '../../customer/pages/CustomerListPage/utils/customerFilter.utils';

export const ACCOUNTS_RECEIVABLE_INSTALLMENTS_LIST_FILTER_PREFIXES = {
  customerClassification: 'customerClassificationPrefix',
};

export const ACCOUNTS_RECEIVABLE_INSTALLMENTS_LIST_FILTER_KEYS = {
  [CUSTOMERS_IDS_KEYS[0]]: CUSTOMERS_IDS_KEYS[0],
  [CUSTOMERS_IDS_KEYS[1]]: CUSTOMERS_IDS_KEYS[1],
  customerCityIds: 'customerCityIds',
  customerStates: 'customerStates',
  customerSalesRepresentativeIds: 'customerSalesRepresentativeIds',
  [ACCOUNTS_RECEIVABLE_INSTALLMENTS_LIST_FILTER_PREFIXES.customerClassification]:
    'customerClassificationIds',
  invoicesIds: 'invoicesIds',
  dueAtStart: 'dueAtStart',
  dueAtEnd: 'dueAtEnd',
  dueAtShortcut: 'dueAtShortcut',
  dueAtShortcutStep: 'dueAtShortcutStep',
  receivableCodes: 'receivableCodes',
  receivableCode: 'receivableCode',
  installmentStatus: 'installmentStatus',
  documentType: 'documentType',
  paidAtStart: 'paidAtStart',
  paidAtEnd: 'paidAtEnd',
  paidDateShortcut: 'paidDateShortcut',
  paidDateShortcutStep: 'paidDateShortcutStep',
  brandIds: 'brandIds',
};

export const ACCOUNTS_RECEIVABLE_BRAND_ENVIRONMENT_ONLY_FILTER_KEYS: string[] = [
  ACCOUNTS_RECEIVABLE_INSTALLMENTS_LIST_FILTER_KEYS.receivableCodes,
  ACCOUNTS_RECEIVABLE_INSTALLMENTS_LIST_FILTER_KEYS.invoicesIds,
];

export function excludeBrandEnvironmentOnlyFilters(filters: DefaultFilters): DefaultFilters {
  const nextFilters: DefaultFilters = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (!ACCOUNTS_RECEIVABLE_BRAND_ENVIRONMENT_ONLY_FILTER_KEYS.includes(key)) {
      nextFilters[key] = value;
    }
  });

  return nextFilters;
}
